import { ModelTranslator } from '@/types/ApiResponseTypes'
import { cdrBodyResponse } from '@/types/cdr/CdrResponse'
import { isCdrBody } from '@/types/cdr/CdrType'

class CdrResponseTranslator implements ModelTranslator<cdrBodyResponse> {
  convertToModel(model: any): cdrBodyResponse {
    if (isCdrBody(model)) {
      return {
        from_Date: this.convertDateToString(model.startDate),
        to_Date: this.convertDateToString(model.endDate),
        phone_number: model.phoneNumber,
      }
    }
    return { from_Date: '', to_Date: '', phone_number: '' }
  }

  convertDateToString(time: Date): string {
    const year = time.getFullYear().toString()
    const month = (time.getMonth() + 1).toString().padStart(2, '0')
    const day = time.getDate().toString().padStart(2, '0')
    return `${year}${month}${day}`
  }
}

export default new CdrResponseTranslator()
